document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('GB');
  if (!root) return;

  const animatedElements = root.querySelectorAll('.anime');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    }, { threshold: 0.1 });

    animatedElements.forEach((element) => observer.observe(element));
  } else {
    animatedElements.forEach((element) => element.classList.add('active'));
  }
});
